import {ApiClientService, EntityApiService} from '@dofleini/security';

class RegistersApiService extends EntityApiService {
    checkIsPending = (params) => {
      return ApiClientService.post(this.getPath('/check-pending'), params);
    }

    search = (params) => {
      return ApiClientService.post(this.getPath('/search'), params);
    }

    searchForClientsUser = (params) => {
      return ApiClientService.post(this.getPath('/search-for-client-user'), params);
    }
    
    checkPendingRegisters = (params) => {
      return ApiClientService.post(this.getPath('/pending/check-all'), params);
    }

    openCloseRegister = (params) => {
      return ApiClientService.patch(this.getPath(`/${params?._id}/open-close`), params);
    }
    getOneForClient = function (id, config) {
      return ApiClientService.get('/ms-registry/api/registers/client/' + id, config);
    };
    
}

export default new RegistersApiService('/ms-registry/api/registers');
